"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appConfigHelper = require("../../util/appConfigHelper");
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
const listCustomerTransactions = async function () {
  let limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const API_URL = (0, _environmentHelper.default)();
  const {
    customerId
  } = (0, _jwtDecode.default)((0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN'));
  const url = "".concat(API_URL, "/customers/").concat(customerId, "/transactions?limit=").concat(limit, "&offset=").concat(offset);
  return (0, _fetchHelper.default)(url, {
    method: 'GET'
  }).then(async res => {
    const {
      responseData,
      errors
    } = await res.json();
    if (!res.ok) {
      throw new Error(errors[0]);
    }
    return responseData;
  }).catch(err => {
    throw new Error(err);
  });
};
var _default = exports.default = listCustomerTransactions;